// https://api.anano.com.br/storage/dw/buckets/anano.data.ui/arquivos/365dc2f8-d607-4914-b893-16f263c5fa91/download?access_token=eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJqYW9hc3N5IiwiaWF0IjoxNjk2MjUxNjUzLCJleHAiOjE3MTE4MDM2NTN9.Yyc6BZpewKc-rfg4309cxVPD5JcGujVgUrhBxnIhoTM
import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    loading: false,
    ultimaAlteracao: "",
    data: [],
    dataFiltered: [],
    faturamento: null,
    ordem: "Fatur. Mensal",
    hidePrint : false,
    filtros: {
        curva: "TODAS",
        recencia: "TODAS",
        frequencia: "TODAS",
        novo: "TODAS",
        cliente: "",
        pf: "TODAS",
    }
}

export const clientesSlice = createSlice({
    name: "clientes",
    initialState,
    reducers: {
        triggerLoadData: () => { },
        setAttribute: (state, action) => {
            state[action.payload.campo] = action.payload.valor
        },
        doFilter: (state, action) => {
            var filtered = state.data
                .filter(e => {
                    if (state.filtros.curva == "TODAS") return true
                    return e.curva.startsWith(state.filtros.curva)
                })
                .filter(e => {
                    if (state.filtros.recencia == "TODAS") return true
                    return (state.filtros.recencia == e.recencia.toUpperCase())
                })
                .filter(e => {
                    if (state.filtros.frequencia == "TODAS") return true
                    return e.frequencia.toUpperCase() == state.filtros.frequencia
                })
                .filter(e => {
                    if (state.filtros.novo == "TODAS") return true
                    return e.novo
                })
                .filter(e => {
                    if (state.filtros.cliente.trim().length == 0) return true
                    return e.nome.toUpperCase().includes(state.filtros.cliente.toUpperCase())
                })
                .filter(e => {
                    if (state.filtros.pf == "TODAS") return true
                    var p = e.pf ? "PF" : "PJ"
                    return state.filtros.pf == p
                })

            filtered.sort( (a,b) => {
                if(state.ordem == "Fatur. Mensal") {
                    return a.retornoMensalCru > b.retornoMensalCru ? -1 : 1
                } else {
                    return a.nome.trim() > b.nome.trim() ? 1 : -1
                }
            })

            state.dataFiltered = filtered
        },
        setFiltro: (state, action) => {
            state.filtros[action.payload.campo] = action.payload.valor
        },
        setOrdem: (state, action) => {
            state.ordem = action.payload
        },
        triggerTrocaFiltro: () => { },
        triggerToggleHiddenPrint : (state) => {
            state.hidePrint = !state.hidePrint
        }
    }
})

export const {
    triggerLoadData,
    setAttribute,
    setFiltro,
    triggerTrocaFiltro,
    doFilter,
    setOrdem,
    triggerToggleHiddenPrint
} = clientesSlice.actions;


export default clientesSlice.reducer;